{
  "dashboard": {
    "tabs": {
      "addTabDialog": {
        "title": "Добавить вкладку",
        "selectDashboard": "Выбрать дашборд",
        "dashboard": "Дашборд",
        "name": "Имя",
        "restoreFromHistory": "Восстановить из истории",
        "newTab": "Новая вкладка"
      }
    },
    "access": {
      "missingDashboardAccess": "Одна из панелей удалена из-за изменения настроек доступа."
    },
    "NewWidget": {
      "widget": "Виджет",
      "new": "Новый",
      "existing": "Существующий"
    },
    "dashboardModal": {
      "title": "Создание виджета"
    },
    "CreateDashboard": {
      "title": "Отображаемое имя",
      "name": "Имя",
      "tql": "Запрос",
      "ciTypeBindings": "Привязки типов КЕ",
      "ciTypeBindingsHint": "Для каждого типа КЕ выберите узел TQL, чтобы открывать дашборд с фильтром по КЕ.",
      "ciTypeBindingNode": "Узел TQL",
      "ciTypeBindingNodePlaceholder": "Открывать без фильтра по КЕ",
      "ciTypeBindingInherited": "наследует",
      "ciTypeBindingDescendants_one": "+ {{count}} наследник",
      "ciTypeBindingDescendants_few": "+ {{count}} наследника",
      "ciTypeBindingDescendants_many": "+ {{count}} наследников",
      "ciTypeBindingDescendants_other": "+ {{count}} наследника",
      "ciTypeBindingNoDescendants": "нет наследников",
      "privacy": "Приватность",
      "private": "Частный",
      "general": "Общий",
      "template": "Шаблон",
      "time": "Настройка времени",
      "interval": "Интервал",
      "refresh": "Обновления"
    },
    "CreateWidget": {
      "PreviewBlock": {
        "title": "Выберите Widget и Тип данных для отображения"
      },
      "DataTypeSelect": {
        "label": "Тип данных",
        "placeholder": "Выберите тип данных"
      },
      "HiSelect": {
        "hiType": "Тип индикатора",
        "hi": "Индикатор",
        "ciLabel": "КЕ",
        "hiLabel": "Индикатор"
      },
      "MetricSelect": {
        "metric": "Метрики",
        "metricQuery": "Запрос {{index}}"
      },
      "SourceBlock": {
        "title": "Источник данных"
      }
    },
    "CreateTabDialog": {
      "title": "Добавить вкладку"
    },
    "SelectFromDashboardList": {
      "create": "Создать Дэшборд",
      "select": "Выбрать существующий Дэшборд",
      "label": "Дэшборд"
    },
    "CreateDashboardDialog": {
      "create": "Создание дашборда",
      "edit": "Изменение дашборда"
    },
    "timeRange": {
      "absolute": "Абсолютный интервал",
      "relative": "Относительное время"
    },
    "timeInterval": {
      "typeError": "Не корректные типы данных в полях",
      "validationError": "Поле От должно быть меньше поля То",
      "absolute": "Абсолютный интервал",
      "relatively": "Относительное время",
      "from": "От",
      "to": "До",
      "5m": "Последние 5 минут",
      "15m": "Последние 15 минут",
      "30m": "Последние 30 минут",
      "1h": "Последний час",
      "3h": "Последние 3 часа",
      "6h": "Последние 6 часов",
      "12h": "Последние 12 часов",
      "1d": "Последний день",
      "2d": "Последний 2 дня",
      "5d": "Последние 5 дней",
      "1week": "Последняя неделя",
      "month": "Последний месяц"
    }
  },
  "dashboardPage": {
    "title": "Реестр дашбордов",
    "columns": {
      "id": "Id",
      "title": "Название",
      "name": "Системное имя",
      "tags": "Теги",
      "query": "Запрос",
      "isPrivate": {
        "title": "Приватность",
        "private": "Личный",
        "general": "Общий"
      },
      "deleteTitle": "Удаление дашборда может удалить на существующие вкладки. Продолжить?",
      "action": "Действия"
    },
    "addDashboardTitle": "Добавление дашборда"
  },
  "dataType": {
    "hi": "Индикаторы статуса",
    "metric": "Метрики",
    "newMetric": "Линейный график",
    "events": "События",
    "attributes": "Аттрибуты",
    "graph": "Граф"
  },
  "options": {
    "addGrid": "Добавить ячейку",
    "settings": "Настройки дашборда",
    "interval": "Интервал времени",
    "refresh": {
      "refresh": "Обновить",
      "refreshInterval": "Интервал обновления"
    },
    "fullscreen": "Полноэкранный режим"
  },
  "CITree": {
    "setDashboard": "Не назначен дашборд на данное ТКЕ",
    "selectCIT": "Выберите ТКЕ"
  }
}
